import { render, staticRenderFns } from "./AccettazioneSsnImpegnativaModalComponent1.vue?vue&type=template&id=7a84fbd2&scoped=true"
import script from "./AccettazioneSsnImpegnativaModalComponent1.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativaModalComponent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84fbd2",
  null
  
)

export default component.exports